import React, { useMemo } from 'react';
import { Grid } from 'react-window';
import ArtworkDetails from './ArtworkDetails';

const VirtualizedGallery = ({ artworks, containerWidth = 1200, trailingItem = null }) => {
  const ITEM_WIDTH = 320;
  const ITEM_HEIGHT = 420;
  const GAP = 40;
  const totalItems = artworks.length + (trailingItem ? 1 : 0);

  const { columnCount, rowCount } = useMemo(() => {
    const cols = Math.floor(containerWidth / ITEM_WIDTH) || 1;
    const rows = Math.ceil(totalItems / cols);
    return { columnCount: cols, rowCount: rows };
  }, [totalItems, containerWidth]);

  const Cell = ({ columnIndex, rowIndex, style }) => {
    const index = rowIndex * columnCount + columnIndex;

    if (index >= totalItems) return null;

    if (trailingItem && index === artworks.length) {
      return (
        <div
          style={{
            ...style,
            padding: GAP / 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}
        >
          {trailingItem}
        </div>
      );
    }

    const artwork = artworks[index];

    if (!artwork) return null;

    return (
      <div
        style={{
          ...style,
          padding: GAP / 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
      >
        <ArtworkDetails artwork={artwork} />
      </div>
    );
  };

  if (totalItems === 0) return null;

  return (
    <div className="w-full flex justify-center">
      <Grid
        columnCount={columnCount}
        columnWidth={ITEM_WIDTH}
        height={Math.min(600, rowCount * ITEM_HEIGHT)}
        rowCount={rowCount}
        rowHeight={ITEM_HEIGHT}
        width={Math.min(containerWidth, columnCount * ITEM_WIDTH)}
        style={{
          overflowX: 'hidden',
        }}
      >
        {Cell}
      </Grid>
    </div>
  );
};

export default VirtualizedGallery;
